import { createContext } from 'react';

export const emptyContext = {
    userCurrentOhrequests:[],
    userAllowedOhrequestsTypes:[]
};

const AppContext = createContext(emptyContext);
AppContext.displayName = "AppContext";
export default AppContext;